export const changePlan = {
  listHeading: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-30)',
    letterSpacing: '0em',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)'
  },
  listHeadingOne: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-32)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-mid)',
    marginLeft: '11px'
  },
  planButton: {
    backgroundColor: 'var(--color-primary)',
    // backgroundColor: 'rgb(37, 211, 176)',
    borderColor: 'rgb(37, 211, 176)',
    color: '#1a1a1a',
    fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' },
    // '&:hover': { backgroundColor: 'rgb(37, 211, 176)' },
    width: '175px',
    height: '40px',
    padding: '8px, 16px, 8px, 16px',
    borderRadius: '6px',
    gap: '8px',
    marginTop: '15px'
  },
  planDetailText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: '600',
    lineHeight: 'var(--line-height-24)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'rgba(29, 41, 57, 1)'
  },
  featureText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: '700 !important',
    lineHeight: 'var(--line-height-28)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-dark2)',
    width: '286px',
    padding: '12px'
  },
  valueText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    letterSpacing: '0em',
    textAlign: 'center',
    padding: '12px',
    color: 'var(--color-primary)'
  },
  planButtonText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: '500 !important',
    lineHeight: 'var(--line-height-24)',
    letterSpacing: '0em',
    textAlign: 'center',
    color: 'var(--color-white)'
  },
  toggleLabelText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    backgroundColor: (theme) => theme.palette.primary.main,
    border: '1px solid black',
    borderRadius: '100px',
    color: (theme) => theme.palette.common.white,
    width: '135px',
    paddingTop: '6px',
    paddingBottom: '6px',
    textTransform: 'none'
  },
  helpIconCss: {
    width: '16px',
    height: '16px',
    color: '#A8A6BF',
    marginBottom: '2px',
    marginLeft: '0.3rem'
  },
  planTableIconSx: {
    height: '35px',
    width: '35px',
    borderRadius: 0,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  discountChipSx: {
    color: '#C11574',
    background: '#FDF2FA',
    borderRadius: '16px'
  },
  discountChipLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center'
  },
  saveUptoChip: {
    position: 'absolute',
    top: '-20px',
    right: '19px',
    backgroundColor: 'var(--color-success-bg)',
    color: 'var(--color-primary)',
    borderRadius: '32px',
    width: '108px',
    height: '22px',
    padding: '5px',
    '& .MuiChip-label': {
      padding: '0px !important',
      paddingLeft: '0px !important',
      paddingRight: '0px !important'
    }
  },
  toggleLabelChecked: {
    textTransform: 'none',
    width: '135px',
    border: '1px solid var(--color-bg-light-purple)',
    borderRadius: '100px'
  },
  toggleButtonGroupSx: {
    '& .MuiToggleButton-root': {
      backgroundColor: 'transparent', // Remove default background color
      border: 'none',
      '&:hover': {
        backgroundColor: 'transparent' // Remove hover background color
      }
    },
    '& .Mui-selected': {
      backgroundColor: 'transparent !important' // Remove selected background color
    }
  },
  switchBtnBox: {
    height: '45px',
    border: '1px solid #AA95E2',
    width: '292px',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '40px',
    marginTop: '40px',
    backgroundColor: 'var(--color-white)'
  },
  toggleButtonSx: {
    border: 'none',
    borderColor: 'none !important',
    width: '150px',
    padding: '0px !important',
    '& .MuiToggleButton-root': {
      padding: '0px !important'
    },
    '& .active-toggle': {
      padding: '0px !important'
    },
    '& .inactive-toggle': {
      padding: '0px !important'
    }
  },
  chipText: {
    fontFamily: 'Inter',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 'var(--line-height-14)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    padding: '0px !important',
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    '& .MuiChip-label': {
      padding: '0px !important',
      paddingLeft: '0px !important',
      paddingRight: '0px !important'
    }
  },
  spacingBox: {
    height: '9rem'
  },
  titleCellSx: {
    width: '0px'
  },
  headerBoxNew: {
    padding: '24px 20px 20px 20px',
    gap: '24px',
    borderRadius: '8px',
    border: '1px solid red'
  },
  cardDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: 'var(--line-height-18)'
  }
};
